'use client';

import Image from 'next/image';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

interface ThemeAwareLogoWithTextProps {
  width?: number;
  height?: number;
  className?: string;
}

export function ThemeAwareLogoWithText({ width = 180, height = 40, className = '' }: ThemeAwareLogoWithTextProps) {
  const { resolvedTheme } = useTheme();
  const [logoSrc, setLogoSrc] = useState('/images/logo-black-with-text.png');
  const [mounted, setMounted] = useState(false);

  // Only render logo after mounting to avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      setLogoSrc(resolvedTheme === 'dark' ? '/images/logo-white-with-text.png' : '/images/logo-black-with-text.png');
    }
  }, [resolvedTheme, mounted]);

  if (!mounted) {
    return null; // Avoid rendering during SSR
  }

  return (
    <Image
      src={logoSrc}
      alt="Fomogo"
      width={width}
      height={height}
      className={`transition-transform hover:scale-105 ${className}`}
    />
  );
} 